export enum LinkAppearance {
  Ghost = 'ghost',
  Primary = 'primary',
}
